import { PropsWithChildren } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer as DrawerCreate, IconButton, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';

type DrawerPrizesPropsType = PropsWithChildren<{
  title?: string;
}>;

export const DrawerPrizes = ({ children, title = 'Новый приз' }: DrawerPrizesPropsType) => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);
  return (
    <DrawerCreate
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            {title}
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">{children}</div>
      </DrawerContent>
    </DrawerCreate>
  );
};
